<template>
<div>
   <!--<Section background="white"  class="image-bg"-->
   <!--         :style="{'background-image': `url(${require('../../../assets/images/content/pexels-pixabay-414781-cropped.jpg')})`}"-->

   <!--&gt;-->
   <!--   <nav-bar dark></nav-bar>-->
   <!--   <div class=" main-heading" style=" width: 100%;" >-->
   <!--      <v-container fluid class="heading-line">-->
   <!--         <div class="center display-2">Videos</div>-->
   <!--      </v-container>-->
   <!--   </div>-->
   <!--</Section>-->



   <div style="padding:10px">
      <template v-if="path==='namihira-story'">
         <article >
            <h1>The Doctor On Crutches</h1>
            <p> The story of Dr. Namihira and how he overcame the hurdles of his early childhood, came to Christ,
               and ultimately becoming a successful doctor.
            </p>

            <div class="flex-center">
               <iframe width="640" height="480" src="//www.youtube.com/embed/YD52fdUIoS0?rel=0" frameborder="0" allowfullscreen></iframe>
            </div>

         </article>
      </template>




      <template v-else-if="path==='cosmic-conflict'">
         <article >

            <h1>Cosmic Conflict</h1>
            <p> The story of how Lucifer became Satan by Amazing Facts, and translated by Mieko.
            </p>


            <div class="flex-center">
               <iframe width="640" height="480" src="//www.youtube.com/embed/dHKDTBwmbPk" frameborder="0" allowfullscreen></iframe>
            </div>
         </article>
      </template>



      <template v-else-if="path==='final-events'">
         <article >

            <h1>
               <!--Final Events-->
               世の終りの諸事件
            </h1>
            <p>

            </p>


            <div class="flex-center">
               <!--<iframe width="640" height="480" src = "https://www.youtube.com/embed/rk-LbQh0Cac" frameborder="0" allowfullscreen></iframe>-->
               <iframe width="640" height="480" src = "https://www.youtube.com/embed/ACAb4Q6YARY" frameborder="0" allowfullscreen></iframe>
            </div>
         </article>
      </template>



      <template v-else-if="path==='lamp-in-dark'">
         <article >

            <h1>
               暗黒の中のランプ
            </h1>
            <p>

            </p>

            <div class="flex-center">
               <iframe width="640" height="480" src="//www.youtube.com/embed/RIhn6o0q1qU"
                       frameborder="0" allowfullscreen
               ></iframe>
            </div>
         </article>
      </template>


      <template v-else-if="path==='bride-beast-babylon'">
         <article >

            <h1>
               黙示録、花嫁、獣、そして、バビロン
            </h1>
            <p>

            </p>

            <div class="flex-center">
               <iframe width="640" height="480" src="https://www.youtube.com/embed/cs6_nfl9DlA"
                       frameborder="0" allowfullscreen
               ></iframe>
            </div>
         </article>
      </template>




      <template v-else-if="path==='kingdom-in-time'">
         <article >

            <h1>
               各時代の王国
            </h1>
            <p>

            </p>

            <div class="flex-center">
               <iframe width="640" height="480" src="https://www.youtube.com/embed/yY8c5cTMVYw"
                       frameborder="0" allowfullscreen
               ></iframe>
            </div>
         </article>
      </template>


      <template v-else-if="path==='rome-in-prophecy'">
         <article >

            <h1>
               預言の中のUSA とローマ
            </h1>
            <p>

            </p>

            <div class="flex-center">
               <iframe width="640" height="480" src="https://www.youtube.com/embed/5SXl-sq7w1I"
                       frameborder="0" allowfullscreen
               ></iframe>
            </div>
         </article>
      </template>


      <template v-else-if="path==='landmarks-prophecy'">
         <landmark-prophecy/>
      </template>



      <template v-else-if="path==='life-at-its-best'">
         <life-at-best/>
      </template>



      <template v-else-if="path==='dark-clouds-over-elberton'">
         <article >

            <h1>
               エルバートンの暗い雲
            </h1>
            <p>

            </p>

            <div class="flex-center">
               <iframe width="640" height="480" src="https://www.youtube.com/embed/HI5xFwo1ebc"
                       frameborder="0" allowfullscreen
               ></iframe>
            </div>
         </article>
      </template>





   </div>

</div>
</template>

<script>
import navBar from "@/components/navBar";
import Section from "@/components/Section";

import landmarkProphecy from "@/views/jp/videos/landmarkProphecy";
import lifeAtBest from "@/views/jp/videos/lifeAtBest";

export default {
   name: "videos",
   components: {navBar, Section, landmarkProphecy, lifeAtBest},
   data(){
      return {
         path: null,
      }
   },
   watch:{
      $route(to, from){
         this.path = this.$route.params.path;
      }
   },


   created(){
      let path = this.$route.params;
      this.path = this.$route.params.path;


      console.log(path)
   }
}
</script>

<style scoped>
.image-bg{
    background-size: cover;
    background-position: center;
    height: 300px;
}

td{
    padding-left: 10px;
    padding-right: 10px;
}


.main-heading{
    height: 200px;
    display: flex;
    align-items: center;
    justify-content: center;

}


.heading-line{
    text-align: center;
    color:#ffffff;
    /*background-color:rgba(43,43,43,0.4);*/
    width: 100%;

}
</style>